import { render, staticRenderFns } from "./JSONPreview.vue?vue&type=template&id=40226a33&"
import script from "./JSONPreview.vue?vue&type=script&lang=js&"
export * from "./JSONPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports